import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';

import { WidgetSetupComponent } from './setup/form/widget_setup.component';
import { InstallSharedModule } from '../shared/install_shared.module';
import { WidgetPreviewComponent } from './setup/preview/widget_preview.component';
import { FormsModule } from '@angular/forms';
import { UiSwitchModule } from 'angular2-ui-switch';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SelectModule } from 'ng-select';
import { WidgetService } from '../shared/services/widget.service';

@NgModule({
  imports: [
    CommonModule,
    UiSwitchModule,
    InstallSharedModule,
    PopoverModule.forRoot(),
    FormsModule,
    SelectModule
  ],
  declarations: [
    WidgetSetupComponent,
    WidgetPreviewComponent
  ],
  providers: [
    WidgetService
  ]
})
export class WidgetModule {}
